const registrarTable = [
  {
    value: 'class_code',
    name: '班级代码'
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'org',
    name: '部门'
  },
  {
    value: 'specialized',
    name: '项目',
    isHide: true
  },
  {
    value: 'fee',
    name: '级别'
  },
  {
    value: 'teacher',
    name: '教师',
    isHide: true
  },
  {
    value: 'courses_count',
    name: '课次',
    isHide: true
  },
  {
    value: 'class_fee',
    name: '学费',
    isHide: true
  },
  {
    value: 'total_fee',
    name: '总费用',
    isHide: true
  },
  {
    value: 'scud',
    name: '课程表',
    isHide: true
  },
  {
    value: 'class_time_sp',
    name: '课程安排',
    option: {
      'min-width': '120px'
    }
  },
  {
    value: 'class_size',
    name: '预计人数',
    isHide: true
  },
  {
    value: 'class_count',
    name: '实际人数',
    isHide: true
  },
  {
    value: 'sign_up_count',
    name: '报名人数',
    isHide: true
  },
  {
    value: 'reserved_count_row',
    name: 'Y',
    option: {
      width: '56px',
      align: 'center'
    }
  },
  {
    value: 'minister_sign_up_count',
    name: 'B',
    option: {
      width: '56px',
      align: 'center'
    }
  },
  {
    value: 'countStatus',
    name: '预约/实招/预招',
    option: {
      width: '105px',
      align: 'center'
    }
  },
  {
    value: 'publish_status',
    name: '发布状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'sign_up_status',
    name: '报名状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'class_phase',
    name: '课程状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'create_user_name',
    name: '创建者',
    isHide: true
  },
  {
    value: 'create_time',
    name: '创建时间',
    isHide: true
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '154px'
    }
  }
];

const signUpTable = [
  {
    value: 'term_label',
    name: '学期',
    option: {
      width: '60px'
    }
  },
  {
    value: 'reservation_number',
    name: '预约号',
    option: {
      width: '100px'
    }
  },
  {
    value: 'class_code',
    name: '班级代码',
    option: {
      width: '94px'
    }
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'class_time_sp',
    name: '课程安排',
    option: {
      'min-width': '120px'
    }
  },
  {
    value: 'pay_end_time',
    name: '缴费截至时间'
  },
  {
    value: 'org_full_name',
    name: '部门'
  },
  {
    value: 'specialized_subject_full_name',
    name: '项目'
  },
  {
    value: 'contact_name',
    name: '学员姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'id_card_no',
    name: '证件号',
    isHide: true
  },
  {
    value: 'real_name',
    name: '家长姓名',
    isHide: true
  },
  {
    value: 'phone',
    name: '家长手机'
  },
  {
    value: 'teacher',
    name: '教师姓名',
    isHide: true
  },
  {
    value: 'create_time',
    name: '报名时间',
    isHide: true
  },
  {
    value: 'sign_up_type',
    name: '报名方式'
  },
  {
    value: 'sign_up_status',
    name: '报名状态'
  },
  {
    value: 'real_fee',
    name: '实际缴费'
  },
  {
    value: 'total_fee',
    name: '班级缴费'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '110px'
    }
  }
];

export { registrarTable, signUpTable };
